<template>
    <vs-tooltip :text="customTooltip">
  <span>
      <vs-icon
          :class="{
            'text-success': status === 'validated',
            'text-warning': status === 'pending_validation',
            'text-danger': status === 'error',
          }"
          icon="circle"></vs-icon>
  </span>
      </vs-tooltip>
</template>

<script>
export default {
  name: "CsdStatusIcon",
  computed: {
    customTooltip() {
      switch (this.status) {
        case 'validated':
            return 'Validado';
        case 'pending_validation':
          return 'Pendiente de validar';
        case 'error':
          return this.statusDescription;
      }
    }
  },
  props: {
    status: {
      type: String,
      required: true
    },
    statusDescription: {
      type: [String, null],
    }
  }
}
</script>

<style scoped>

</style>
